export default __webpack_public_path__ + "static/media/android.c1ff4192.svg";